import {Injectable} from '@angular/core';

import 'rxjs/add/operator/toPromise';

import {User} from '../model/Entities/User';
import 'rxjs/add/operator/map';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/operator/catch';
import {ApiService} from './api.service';
import 'rxjs/add/operator/delay';
import 'rxjs/add/operator/do';
import {Document} from '../model/Entities/Document';
import {PaymentType, PaymentTypeEntity} from '../model/Entities/PaymentType';
import {Vat} from '../model/Entities/Vat';

@Injectable()
export class VatService extends ApiService<Vat> {

    protected apiUrl = 'api/vat';  // URL to web api

    protected getObjectType(): any {
        return Vat;
    }
}



// WEBPACK FOOTER //
// /app/src/services/vat.service.ts